const peiServiceNeeds = {
  Nutrition: 1929,
  Hygiene: 1930,
  Mobility: 1932,
  healthAnxiety:1994,
  healthsupportForHealthNeeds:2082,
  healthCatheterization:1992,
  healthColostomy:1995,
  healthDiabetes:3078,
  healthGastrostomy:1996,
  healthMedication:1997,
  Communication: 2071,
  Transportation: 1937,
  CommunicationV2: 3133,
  MedicationAdministration: 3155,
  IsNotRequired: 87
};
export default peiServiceNeeds;
